import CONTACT_STATES from 'lib/common/constants/contactStates';

import { CONNECT_CONTACT_STATE_MAP } from './newBaseTask';

export const PREVIEW_DIALING_CONNECT_CONTACT_STATE_MAP = {
  ...CONNECT_CONTACT_STATE_MAP,
  [connect.ContactStateType.ERROR]: CONTACT_STATES.ERROR,
  [connect.ContactStateType.PENDING]: CONTACT_STATES.PENDING,
};
